<template>
  <aside id="mini-overview">
    <nav>
      <ul :class="{ 'active-menu' : configMenu }">
        <li @click="toggleMenu('configMenu')" v-ripple class="sub-menu-toggle"><img src="../assets/img/icons/items/funktionen.svg" alt="Konfigurieren" /><span>Konfigurieren</span></li>
        <transition name="slide" mode="out-in">
          <ul v-if="configMenu">
            <li><router-link v-ripple to="/" :class="linkClasses">Start</router-link></li>
            <li><router-link v-ripple to="/templates" :class="linkClasses">Templates</router-link></li>
            <li><router-link v-ripple to="/sprachen" :class="linkClasses">Sprachen</router-link></li>
            <li><router-link v-ripple to="/plugins" :class="linkClasses">Plug-ins</router-link></li>
            <transition name="expand" mode="out-in">
              <li v-if="blogfunktionActive"><router-link v-ripple to="/blog" :class="linkClasses">Blog-Funktionen</router-link></li>
            </transition>
            <transition name="expand" mode="out-in">
              <li v-if="shopfunktionActive"><router-link v-ripple to="/shop" :class="linkClasses">Shop-Funktionen</router-link></li>
            </transition>
            <li><router-link v-ripple to="/technisches" :class="linkClasses">Technisches</router-link></li>
            <li><router-link v-ripple to="/services" :class="linkClasses">Services</router-link></li>
            <li><router-link v-ripple to="/zusammenfassung" :class="linkClasses">Kurzübersicht</router-link></li>
          </ul>
        </transition>
      </ul>
      <ul :class="{ 'active-menu' : profileMenu }" class="profile-menu">
        <li @click="toggleMenu('profileMenu')" v-ripple class="sub-menu-toggle"><img src="../assets/img/icons/items/basics.svg" alt="Profil" /><span>Ihr Profil</span></li>
        <transition name="slide" mode="out-in">
          <ul v-if="profileMenu">
            <li><router-link v-ripple to="/account" :class="linkClasses">Account</router-link></li>
            <li><router-link v-ripple to="/projekte" :class="linkClasses">Projekte</router-link></li>
          </ul>
        </transition>
      </ul>
      <!--<router-link v-ripple v-for="route in $router.options.routes" :key="route.path" :to="route.path" :class="linkClasses" />-->
    </nav>
  </aside>
</template>

<script>
export default {
  name: 'MiniOverview',
  data: function () {
    return {
      configMenu: true,
      profileMenu: false,
      linkClasses: 'page-controller flex-container align-items-center needsclick'
    }
  },
  computed: {
    currentRouteName: function () {
      return this.$route.name
    },
    blogfunktionActive: function () {
      if (this.$root.items.find(item => item.id === 'blogfunktion').status) {
        return true
      } else {
        return false
      }
    },
    shopfunktionActive: function () {
      if (this.$root.items.find(item => item.id === 'onlineshop').status) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    toggleMenu: function (subMenu) {
      if (subMenu === 'configMenu') {
        this.$router.push('/')
        this.configMenu = true
        this.profileMenu = false
      } else {
        this.$router.push('/account')
        this.configMenu = false
        this.profileMenu = true
      }
    }
  },
  mounted: function () {
    if (this.currentRouteName === 'Account' || this.currentRouteName === 'Projekte' || this.currentRouteName === 'Timeline') {
      this.configMenu = false
      this.profileMenu = true
    } else {
      this.configMenu = true
      this.profileMenu = false
    }
  },
  watch: {
    currentRouteName: function (val) {
      if (val === 'Account' || val === 'Projekte' || val === 'Timeline') {
        this.configMenu = false
        this.profileMenu = true
      } else {
        this.configMenu = true
        this.profileMenu = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/variables.scss";
#mini-overview {
  display: none;
  height: 100%;
  width: 102px;
  padding-top: 80px;
  background: #FCFCFC;
  position: fixed;
  z-index: 10;
  nav {
    margin: 0;
    list-style: none;
    padding: 20px 0 0 0;
    height: 100%;
    overflow: auto;
    overflow-x:hidden;
    overflow-y:auto;
    -webkit-overflow-scrolling: touch;
    ul {
      margin: 0;
      padding: 0px 0 3px 0;
      border-top: 1px solid transparent;
      &.profile-menu {
        margin-bottom: 40px;
      }
      &.active-menu {
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
        background: #f7f7f7;
      }
      li {
        margin: 0;
        padding: 0;
        list-style: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 12px;
        padding: 10px 0;
        font-family: $primaryFont;
        font-weight: $primaryFontBold;
        &:hover {
          cursor: pointer;
        }
        img {
          width: 24px;
          height: 24px;
          border-radius: 4px;
          margin-bottom: 4px;
        }
      }
      ul {
        margin-bottom: 0;
        li {
          padding: 0;
          a {
            display: flex;
            flex-direction: column;
            font-size: 11px;
            line-height: 1;
            height: 11%;
            min-height: 20px;
            color: #949494;
            text-decoration: none;
            padding: 8px 0 12px 0;
            width: 100%;
            font-family: $secondaryFont;
            font-weight: $secondaryFontNormal;
            &.router-link-exact-active {
              color: $primaryFontColor;
            }
            &:before {
              display: block;
              content:'';
              width: 8px;
              height: 8px;
              background: #B5B5B5;
              border-radius: 4px;
              margin: 6px 0 6px 0;
            }
          }
        }
      }
    }
  }
}

#mini-overview .page-controller:hover {
  cursor: pointer;
}
#mini-overview .page-controller.router-link-exact-active:before {
  background: #5373FF;
}
@media(min-width:400px) {
  #mini-overview {
    height: 100%;
  }
}
@media(min-width:767px) {
  #mini-overview {
    display: block;
  }
}
</style>
